const isIOS = () =>
  ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
    navigator.userAgent,
  ) ||
  // IPad on iOS 13 detection
  (navigator.userAgent.includes('Mac') && 'ontouchend' in document);

const getIOSEnabledExtensions = () => [
  'application/octet-stream', // This will allows all files and jump directly into the file browser
];

export { isIOS, getIOSEnabledExtensions };
